import React, { ChangeEvent } from 'react';
import { Input, Select } from 'sugar-design';

import { CERTIFICATE_TYPE, CERTIFICATE_TYPE_OPTIONS } from '@/constants/common';
import { LOCALES, getI18n } from '@/utils/i18n';

// stylesheet
import styles from './index.cm.styl';

const i18n = getI18n();

type CredentialsType = typeof CERTIFICATE_TYPE_OPTIONS[number]['value'];

interface Props {
  placeholder?: string;
  value: string;
  typeValue?: CredentialsType;
  error?: string;
  warning?: string;
  prohibitedCertificateType: number[];
  onBlur?: () => void;
  onFocus?: () => void;
  onChange: (value: string, type?: CredentialsType) => void;
}

const CredentialsInput: React.FC<Props> = (props) => {
  const {
    value,
    typeValue = CERTIFICATE_TYPE_OPTIONS[0].value,
    placeholder,
    error,
    warning,
    prohibitedCertificateType,
    onBlur,
    onFocus,
    onChange,
  } = props;

  // 计算身份证下拉框中英文环境下的宽度，设置auto Select本身会有样式bug
  const dropDownMenuWidth = i18n.language === LOCALES.ZH_CN ? '160px' : '190px';

  // 证件类型选项国际化
  const certificateTypeOptions = CERTIFICATE_TYPE_OPTIONS.filter((option) => {
    return !prohibitedCertificateType.includes(option.value) || option.value === typeValue;
  }).map((option) => ({
    ...option,
    disabled: prohibitedCertificateType.includes(option.value),
    label: option.label,
  }));

  const onTypeChange = (type: CredentialsType) => {
    // @ts-ignore
    if (type === CERTIFICATE_TYPE.CITIZEN_ID) {
      // 如果是大陆身份证toUpperCase一下将里边的x修正为大写X
      onChange(value?.toUpperCase(), type);
    } else {
      onChange(value, type);
    }
  };
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    if (typeValue === CERTIFICATE_TYPE.CITIZEN_ID) {
      // 如果是大陆身份证toUpperCase一下将里边的x修正为大写X
      onChange(event.target.value?.toUpperCase(), typeValue);
    } else {
      onChange(event.target.value, typeValue);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div>
        <Select
          className={styles.select}
          value={typeValue}
          options={certificateTypeOptions}
          error={error}
          menuWidth={dropDownMenuWidth}
          onBlur={onBlur}
          onChange={onTypeChange}
        />
      </div>
      <div className={styles.number}>
        <Input
          className={styles.input}
          stretched
          clearable={false}
          warning={warning}
          placeholder={placeholder}
          value={value || ''}
          error={!!error} // 如果报错, 这个框只标红, 不做任何处理
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onInputChange}
        />
      </div>
    </div>
  );
};

export default CredentialsInput;
